import { render, staticRenderFns } from "./sidemenu_twitter.vue?vue&type=template&id=32ec0db3&scoped=true&"
import script from "./sidemenu_twitter.vue?vue&type=script&lang=js&"
export * from "./sidemenu_twitter.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu_twitter.vue?vue&type=style&index=0&id=32ec0db3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec0db3",
  null
  
)

export default component.exports